// import Navigator from '@/component/commonPages/layout/Navigator';
// export default {
//     direction: 'column',
//     class: 'r3-horizontal-content',
//     items: [{
//             height: 80,
//             class: 'r3-content-Navigator',
//             component: Navigator,
//             name: 'Navigator', // global.showModule.Navigator = false时，此选项不渲染。
//         },
//         {
//             class: 'r3-content-Alert',
//             component: navAlert,
//             name: 'Navigator-Alert',
//         },
//         {
//             weight: 1,
//             class: 'r3-content-div',
//             style: {
//                 backgroundColor: 'red',
//                 overflow: 'hidden',

//             },
//             layout: {
//                 direction: 'row',
//                 class: 'r3-content-box',
//                 items: [{
//                         class: 'r3-content-HistoryAndFavorite',
//                         component: HistoryAndFavorite,
//                     },
//                     {
//                         id: 'ContentDisplayArea',
//                         class: 'r3-content-ContentDisplayArea',
//                         weight: 1,
//                         style: { margin: '20px', backgroundColor: '#fff', overflow: 'hidden' },
//                         component: ContentDisplayArea,
//                     }
//                 ]
//             }
//         }
//     ],
// };
export default {}
